exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-card[data-v-66d0bca0]{border-radius:16px;overflow:hidden}.start-card[data-v-66d0bca0]{border:1px solid #dce8df;border-radius:12px;background:#fbfffc}.progress-card[data-v-66d0bca0]{border:1px solid #d9e8f7;border-radius:12px;background:#f8fbff}.list-card[data-v-66d0bca0]{border:1px solid #e5e8ed;border-radius:12px;min-height:330px}.country-list[data-v-66d0bca0]{max-height:350px;overflow-y:auto}", ""]);

// exports
